
<template>

 <v-dialog max-width="600px" v-model="place.showEditDialog">
   
    <v-card>
      <v-card-title>
        <h2 v-if='place.editType === "name"'>Edit place name</h2>
        <h2 v-if='place.editType === "merge"'>Merge into another place</h2>
        <!-- h2 v-if='place.editType === "hierarchy"'>Change parent</h2 -->        
      </v-card-title>
      <v-card-text>
        <v-form ref="form" onSubmit="return false;" v-if="place.data">
          <v-layout row v-if='place.editType === "name"'>
            <v-flex xs12>
              <v-text-field v-model="place.data.v" label="Place Name"
                :rules="[rules.required, rules.min]" />
            </v-flex>
          </v-layout>

          <v-layout row wrap v-if='place.editType === "merge"'>
              <v-flex xs12 my-3 py-3>        
    
                      <div style="margin-top:-30px;border:1px solid white">
                        <div class="grey--text" style='text-align:left'>All the people and events linked to the current place "{{place.name}}" 
                          will be moved to the new place you choose, and the current place will cease to exist.
                         </div> 
                        <v-autocomplete v-model="mergePlace.select" :items="mergePlace.places" item-text="pn" item-value="id" label="Search for a place to merge into"
                          :search-input.sync="mergePlaceSearch" :loading="mergePlace.loading" single-line return-object @change="mergePlaceChange()">     
                        </v-autocomplete>                        
                      </div>
              </v-flex>
          </v-layout>

          <!-- v-layout row wrap v-if='place.editType === "hierarchy"'>
              <v-flex xs12 my-3 py-3>        
    
                      <div style="margin-top:-30px;border:1px solid white">
                        <div class="grey--text" style='text-align:left'>This current place "{{place.data.v}}" will be moved to a new "parent" you
                          choose in the place hierarchy.  (If you want to make the current place a country, then add a new country and merge the
                          current place into your newly added country.)
                         </div> 
                        <v-autocomplete v-model="mergePlace.select" :items="mergePlace.places" item-text="pn" item-value="id" label="Search for a place to become the new parent of this place"
                          :search-input.sync="mergePlaceSearch" :loading="mergePlace.loading" single-line return-object @change="mergePlaceChange()">     
                        </v-autocomplete>                        
                      </div>
              </v-flex>
          </v-layout -->          
          <provenance-and-note v-bind:record="updatedPlace"/>

          <v-layout row>
              <v-flex xs12>
                <div class="error" v-html="error"></div>
              </v-flex>
          </v-layout>

          <v-layout row>          
              <v-flex xs4>
              </v-flex>
              <v-flex xs4>
                <v-btn dark class="indigo darken-1" @click='editPlace' :loading="loading"><v-icon left >save_alt</v-icon>Save</v-btn>
              </v-flex>
              <v-flex xs4>
              </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
 </v-dialog>
</template>        

<script>

import Panel from '@/components/Panel' ;
import PlaceService from "@/services/PlaceService" ;

export default {
  components: { Panel }, 
  props: {
    place: null
  },
  data () {
    return {

      updatedPlace: { 
        provenance: '',
        note: '',
        type: null
      },

      mergePlace: {  
        name: '',        
        select: {id: -1, pn: ""},
        places: [],
        loading: false,        
        provenance: '',
        note: '',
        pendingSearch: null
      },
      mergePlaceSearch: null, 

      error: null,
      message: null,
      loading: false,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 2 || 'Minimum of 2 characters is required.'
      }
    }
  },
  watch: {
    async mergePlaceSearch (val) {
      if (val && val !== this.mergePlace.select.pn && (val.length >= 2)) {
        this.runMergePlaceSearch(val, this.mergePlace) ;
      }
    }  
  },  
  methods: {
    async mergePlaceChange () {
      console.log("---------------------------------mergePlaceChange: " + JSON.stringify(this.mergePlace.select)) ;
      this.updatedPlace.type = 'merge' ;
      this.updatedPlace.mergedIntoId = this.mergePlace.select.id ;
    },

    async runMergePlaceSearch (val, locp) {

      console.log("runMergePlaceSearch val: " + val) ;
      if (locp.loading) {
        locp.pendingSearch = val ;
        console.log("PENDING SEARCH QUEUED: " + val) ;
        return ;
      }
      locp.loading = true ;
      try {
        const placeType = (this.place.editType === 'merge') ? null : "PARENT" ; // merge can be to any level, hierarchy can only be to a state or country
        const response = await PlaceService.placeFindMatchesOnName(val, true, placeType) ;
        console.log("PlaceService responsed") ; // + JSON.stringify(response)) ;

        locp.places = response.data ;
      }
      catch (err) {
        console.log("placeQuerySelections catch err:" + JSON.stringify(err)) ;
        this.error = err.response.data.error  ;
      }
      finally {
        locp.loading = false ;
        if (locp.pendingSearch) {
          const queuedSearch = locp.pendingSearch ;
          locp.pendingSearch = null ;
          console.log("Queuing pending search.." + queuedSearch) ;
          this.runMergePlaceSearch(queuedSearch, locp) ;
        }
      }
    },

    async editPlace () {

      const updateParms = { id: this.place.id, type: this.place.editType, provenance: this.mergePlace.provenance, note: this.mergePlace.note } ;

      switch (this.place.editType) {
        case "name":      updateParms.newName = this.place.data.v ;  break ;
        case "merge":     updateParms.mergedIntoId = this.mergePlace.select.id ; break ;
        // case "hierarchy": updateParms.newParentId = this.mergePlace.select.id ; break ;
        default:
          this.error = "Unrecognised edit type " + this.place.editType ;
          return ;
      }
      this.error = "" ;
      console.log("IN editPlace updatedPlace=" + JSON.stringify(updateParms)) ; 

      try {
        this.loading = true ;
        const response = await PlaceService.update(updateParms) ;

        // this.message = response.data.message
        console.log("success place update, resp data=" + JSON.stringify(response.data)) ;
        this.place.name = response.data.v ; // update name in parent 
        this.place.data = response.data ;

        this.place.showEditDialog = false ;
        this.$renderToastInParent(this, "Place " + this.place.data.v + " successfully updated") ;
      }
      catch (err) {
        console.log("catch err:" + JSON.stringify(err)) ;
        // console.log("ee=" + err.response.data.error)
        this.error = err.response.data.error  ;
      }
      finally {
        this.loading = false ;
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PlaceEdit.vue